module.exports = __webpack_public_path__ + "static/media/sobre.7c15e80a.png";